import _get from 'lodash/get'
import React, { useEffect, useState } from 'react'
import { connect as connectRedux, useSelector } from 'react-redux'
import { List } from 'immutable'
import compose from 'recompose/compose'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import FormsyForm from 'formsy-react'
import { get as getConfig } from '../../../config/index'
import { getBoundActions } from '../../../actions/index'
import Link, { TARGET_BLANK } from '../../Link/index'
import {
  H5, H2, HEADING_TYPES,
} from '../../Heading/index'
import Button, { TYPES, SIZES } from '../../Button/index'
import IconV2, { ICON_TYPES } from '../../Icon.v2/index'
import ButtonSignUp, { BUTTON_SIGN_UP_TYPE_LINK } from '../../ButtonSignUp/index'
import MyAccountMessages, { bottom } from '../MyAccountMessages/index'
import { TextInput } from '../../FormInput.v2/index'
import {
  format as formatDateTime,
  formatDateWithTimezonOffset,
  getDateTime,
  subtractDays,
  ordinalDateFormatingi18n,
  getDateLocale,
  formatWithLocale,
  addMonths,
  getCurrentTime,
} from '../../../services/date-time/index'
import { isEntitled } from '../../../services/subscription/index'
import {
  TYPE_MY_ACCOUNT_CANCEL_WARNING,
  TYPE_PAUSE_RESUME,
} from '../../../services/dialog/index'
import { historyRedirect } from '../../../services/navigation/index'
import { EN } from '../../../services/languages/constants'
import { CANCEL_FLOW_CANCEL_CLICKED_GA4_EVENT } from '../../../services/event-tracking/index'
import {
  USER_ACCOUNT_PAUSED,
  USER_ACCOUNT_CANCELLED,
  USER_ACCOUNT_TRANSACTION_STATUS_DECLINED,
  userShouldReactivate,
  getCurrentPlanInfoFromPlansCall,
  shouldRenderNextPlanSection,
  userPauseAllowed,
  hasScheduledPause,
  hasScheduledOrActivePause,
  showChangePlanLink,
  isPrimaryAccountProfile,
  isTaxable,
  shouldRenderCancelWarningModal,
} from '../../../services/user-account/index'
import {
  selectGiftPaidThroughDate,
} from '../../../services/user-account/selectors'
import { selectMostRecentEligibleEntitlementFromUser } from '../../../services/user/selectors'
import {
  URL_ACCOUNT_CHANGE_PLAN,
  URL_ACCOUNT_CANCEL,
  URL_ACCOUNT_CREATION,
  URL_HELP_CENTER,
  URL_ACCOUNT_PAUSE,
  URL_ACCOUNT_UPDATE_PAYMENT,
} from '../../../services/url/constants'
import { getEmailCustomerServiceUrl } from '../../../services/url/index'
import {
  PLAN_ID_MONTHLY,
  PLAN_ID_FREE_TRIAL,
  PLAN_ID_ONE_MONTH_TRIAL_TO_ANNUAL,
  PLAN_ID_COMPLIMENTARY,
  PLAN_SKU_PRICE_INCREASE_2026_MONTHLY,
  PLAN_SKU_PRICE_INCREASE_2026_ANNUAL,
  PLAN_SKU_PRICE_INCREASE_2026_ARCHITECT_PLUS,
  PLAN_SKU_PRICE_INCREASE_2026_ANNUAL_SPECIAL,
  PLAN_SKU_PRICE_INCREASE_2026_MONTHLY_CL,
  formatPrice,
  planIsGift,
  PLAN_CATEGORY_AI_ONLY,
  PLAN_SUBSCRIPTION_TYPE_GIFT,
} from '../../../services/plans/index'
import { getPrimary } from '../../../services/languages/index'
import Sherpa, { TYPE_LARGE } from '../../Sherpa/index'
import { GIFT_SUBSCRIPTION_STATE } from '../../../services/gift/index'
import { MODAL_TYPES } from '../../Modal/index'
import MyAccountInvoices from '../MyAccountInvoices'

const config = getConfig()
const aiFullAccessActive = !!_get(config, ['features', 'ai', 'fullAccess'])

// If making changes to this file, please look at myAccountDetailsPage as well

// ----------------------------- MY ACCOUNT V2 ---------------------

/* eslint-disable max-len */
function formatStartAndEndDates (reformattedStartDate, reformattedEndDate, formattedEndTime, props) {
  const { staticText } = props
  return (
    <div className="my-account-details-V2__item my-account-details-V2__item--short-details">
      <p className="my-account-details-V2__formatted-trial-time">
        { staticText.get('starts') }
      </p>
      <p className="my-account-details-V2__formatted-trial-time">
        { reformattedStartDate }
      </p>
      <p className="my-account-details-V2__formatted-trial-time">
        {` - ${staticText.get('ends')}`}
      </p>
      <p className="my-account-details-V2__formatted-trial-time">
        { reformattedEndDate }
      </p>
      <p className="my-account-details-V2__formatted-trial-time">
        {staticText.get('at')}
      </p>
      <p className="my-account-details-V2__formatted-trial-time">
        { formattedEndTime }
      </p>
    </div>
  )
}

function hideNextBillDateInCurrentPlanSection (currentPlanId, nextPlanId) {
  if (currentPlanId === PLAN_ID_COMPLIMENTARY) {
    return true
  } if (
    (currentPlanId === PLAN_ID_ONE_MONTH_TRIAL_TO_ANNUAL)
    && (nextPlanId === PLAN_ID_MONTHLY)
  ) {
    return true
  }
  return false
}

function renderFreeTrialDetails (props) {
  const { user, page } = props
  const locale = page.get('locale')
  const freeTrialId = user.getIn(['data', 'freeTrialNoBillingInfo', 'ratePlanId'])
  const freeTrialData = getCurrentPlanInfoFromPlansCall(props, freeTrialId)
  const freeTrialTitle = freeTrialData.getIn([0, 'title'])
  const shortDetails = freeTrialData.getIn([0, 'shortDetails'])
  const dateFormatString = 'MM/DD/YY'
  const timeFormatString = 'hh:mma'
  const mostRecentEntitlement = selectMostRecentEligibleEntitlementFromUser(user)
  const startDateString = mostRecentEntitlement ? mostRecentEntitlement.get('start') : ''
  const endDateString = mostRecentEntitlement ? mostRecentEntitlement.get('end') : ''
  const startDateInMilliseconds = startDateString ? parseInt(startDateString, 10) * 1000 : 0
  const formattedStartDate = new Date(startDateInMilliseconds)
  const getStartDate = getDateTime(formattedStartDate)
  const reformattedStartDate = formatDateTime(getStartDate, locale, dateFormatString)
  const endDateInMilliseconds = endDateString ? parseInt(endDateString, 10) * 1000 : 0
  const formattedEndDate = new Date(endDateInMilliseconds)
  const getEndDate = getDateTime(formattedEndDate)
  const reformattedEndDate = formatDateTime(getEndDate, locale, dateFormatString)
  const formattedEndTime = formatDateTime(getEndDate, locale, timeFormatString)

  if (freeTrialId === PLAN_ID_FREE_TRIAL) {
    return (
      <div className="my-account-details-V2__plan-section">
        <div className="my-account-details-V2__plan-details">
          <H5 className="my-account-details-V2__item my-account-details-V2__item--plan-current">
            { freeTrialTitle }
          </H5>
          <p className="my-account-details-V2__item my-account-details-V2__item--short-details">
            { shortDetails }
          </p>
          { formatStartAndEndDates(reformattedStartDate, reformattedEndDate, formattedEndTime, props) }
        </div>
      </div>
    )
  }
  return null
}

function renderCurrentGiftPlans (giftSubscriptionTitle, gifts, showTitle = true) {
  if (!List.isList(gifts) || !gifts.size) {
    return (
      <div className="my-account-details-V2__plan-placeholder">
        <div className="my-account-details-V2__plan-placeholder-name" />
        <div className="my-account-details-V2__plan-placeholder-details" />
      </div>
    )
  }

  return (
    <>
      {showTitle ? (
        <H5 className="my-account-details-V2__item my-account-details-V2__gift-title">
          {giftSubscriptionTitle}
        </H5>
      ) : null}
      {gifts.map((g, i) => {
        return (
          <p
            key={i}
            className="my-account-details-V2__plan-details"
          >
            {g.get('title')}
          </p>
        )
      })}
    </>
  )
}

function DetailsPlaceholder () {
  return (
    <div className="my-account-details-V2__plan-placeholder">
      <div className="my-account-details-V2__plan-placeholder-name" />
      <div className="my-account-details-V2__plan-placeholder-name" />
      <div className="my-account-details-V2__plan-placeholder-details" />
    </div>
  )
}

/**
 * Reactivation Details
 * @param {Object} props - The props object
 * @param {Map} props.staticText - The static text object
 * @returns {React.ReactNode} The reactivation details component
 */
function ReactivationDetails (props) {
  const { staticText } = props
  return (
    <div className="my-account-details-V2__plan-details--section">
      <div className="my-account-details-V2__plan-details--plan">
        <p className="my-account-details-V2__plan-details--title">
          { staticText.get('welcomeBack') }
        </p>
        <p className="my-account-details-V2__plan-details--message">
          { staticText.get('continueEnjoying') }
        </p>
      </div>
      <div className="my-account-details-V2__plan-details--link">
        <ButtonSignUp
          type={BUTTON_SIGN_UP_TYPE_LINK}
          className="my-account-details-V2__item my-account-details-V2__item--link"
          text={staticText.get('reactivate')}
          scrollToTop
        />
        <IconV2
          className="my-account-details-V2__arrow-right"
          type={ICON_TYPES.CHEVRON_RIGHT}
        />
      </div>
    </div>
  )
}

function ActivePauseDetails (props) {
  const { staticText, resumeDateFormatted } = props
  return (
    <p className="my-account-details-V2__item my-account-details-V2__item--short-details">
      <span className="my-account-details-V2__item--paused">
        {staticText.get('paused')}
      </span> {staticText.get('until')} { resumeDateFormatted }
    </p>
  )
}

/**
 * Presentational layout for the plan details section. Renders slots in BEM structure.
 */
function PlanDetailsSectionTemplate (props) {
  const {
    planHeader,
    planDetails,
    canceledSection,
    actionLink,
    aiOnlyMessage,
    className = '',
  } = props

  return (
    <div className={`my-account-details-V2__plan-section${className ? ` ${className}` : ''}`}>
      <div className="my-account-details-V2__plan-details">
        {planHeader}
        {planDetails}
      </div>
      {canceledSection}
      {actionLink}
      {aiOnlyMessage}
    </div>
  )
}

PlanDetailsSectionTemplate.propTypes = {
  planHeader: PropTypes.node,
  planDetails: PropTypes.node,
  canceledSection: PropTypes.node,
  actionLink: PropTypes.node,
  aiOnlyMessage: PropTypes.node,
  className: PropTypes.string,
}

function PlanDetailsHeader (props) {
  const {
    currentPlanName,
    currentPlanIsGift,
    staticText,
  } = props

  if (!currentPlanIsGift && !currentPlanName) {
    return <DetailsPlaceholder />
  }

  return (
    <>
      <H5 className="my-account-details-V2__item my-account-details-V2__item--plan-current">
        {staticText.get('currentPlan')}
      </H5>
      {!currentPlanIsGift && currentPlanName ? (
        <p className="my-account-details-V2__item my-account-details-V2__current-plan-name">
          {currentPlanName}
        </p>
      ) : null}
    </>
  )
}

PlanDetailsHeader.propTypes = {
  currentPlanName: PropTypes.string,
  subscriptionStatus: PropTypes.string,
  currentPlanIsGift: PropTypes.bool,
  staticText: ImmutablePropTypes.map,
}

function PlanDetailsBody (props) {
  const {
    fullProps,
    subscriptionStatus,
    accountPause,
    resumeDateFormatted,
    accountPausedOrCancelled,
    currentPlanData,
    currentPlanIsGift,
    planData,
    giftSubscriptionTitle,
    scheduledPause,
    staticText,
    pauseDateFormatted,
  } = props

  return (
    <>
      {
        subscriptionStatus === USER_ACCOUNT_PAUSED && accountPause
          ? <ActivePauseDetails {...fullProps} resumeDateFormatted={resumeDateFormatted} /> : null
      }
      {
        !accountPausedOrCancelled && !currentPlanIsGift
          ? <p className="my-account-details-V2__item my-account-details-V2__item--short-details">
              {currentPlanData.getIn([0, 'shortDetails'])}
            </p> : null
      }
      {
        currentPlanIsGift && planData
          ? renderCurrentGiftPlans(giftSubscriptionTitle, planData, false) : null
      }
      {
        scheduledPause
          ? <p className="my-account-details-V2__item my-account-details-V2__item--next-charge">
            { staticText.get('ends') } { staticText.get('on') }: { pauseDateFormatted }
          </p> : null
      }
    </>
  )
}

PlanDetailsBody.propTypes = {
  fullProps: PropTypes.object,
  subscriptionStatus: PropTypes.string,
  accountPause: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  resumeDateFormatted: PropTypes.string,
  accountPausedOrCancelled: PropTypes.bool,
  currentPlanData: ImmutablePropTypes.list,
  currentPlanIsGift: PropTypes.bool,
  planData: PropTypes.object,
  giftSubscriptionTitle: PropTypes.string,
  scheduledPause: PropTypes.bool,
  staticText: ImmutablePropTypes.map,
  pauseDateFormatted: PropTypes.string,
}

const CANCELED_SECTION_VARIANTS = {
  CANCELLED_WITH_TIME_LEFT: 'cancelled-with-time-left',
  ENTITLED_CONTACT_SUPPORT: 'entitled-contact-support',
  NOT_ENTITLED_REACTIVATE: 'not-entitled-reactivate',
}

function CanceledSection (props) {
  const { variant, staticText, formattedCancelDate } = props

  if (variant === CANCELED_SECTION_VARIANTS.CANCELLED_WITH_TIME_LEFT) {
    return (
      <span className="my-account-details-V2__canceled-section">
        <div className="my-account-details-V2__canceled-description">
          <p className="my-account-details-V2__canceled-title">
            <IconV2
              className="my-account-details-V2__icon-alert"
              type={ICON_TYPES.ALERT}
            />
            { staticText.get('canceled') }
          </p>
          <p className="my-account-details-V2__canceled-valid-through">
            { `${staticText.get('validThrough')} ${formattedCancelDate}` }
          </p>
        </div>
        <div className="my-account-details-V2__reactivate-contact-link">
          <Link
            className="my-account-details-V2__reactivate-link"
            to={URL_ACCOUNT_CHANGE_PLAN}
            scrollToTop
          >
            {staticText.get('reactivateYourSubscription')}
          </Link>
          <IconV2
            className="my-account-details-V2__arrow-right"
            type={ICON_TYPES.CHEVRON_RIGHT}
          />
        </div>
      </span>
    )
  }

  if (variant === CANCELED_SECTION_VARIANTS.ENTITLED_CONTACT_SUPPORT) {
    return (
      <span className="my-account-details-V2__canceled-section">
        <div className="my-account-details-V2__canceled-description">
          <p className="my-account-details-V2__canceled-title">
            { staticText.get('canceled') }
          </p>
          <p className="my-account-details-V2__canceled-valid-through">
            { `${staticText.get('validThrough')} ${formattedCancelDate}` }
          </p>
        </div>
        <p className="my-account-details-V2__canceled-valid-through">
          { `${staticText.get('cancelledReactivate')} ` }
          <Link
            to={URL_HELP_CENTER}
            className="my-account-details-V2__item my-account-details-V2__item--link"
          >
            {staticText.get('customerService')}
          </Link>
        </p>
      </span>
    )
  }

  if (variant === CANCELED_SECTION_VARIANTS.NOT_ENTITLED_REACTIVATE) {
    return (
      <span className="my-account-details-V2__canceled-section">
        <div className="my-account-details-V2__canceled-description">
          <p className="my-account-details-V2__canceled-title">
            { staticText.get('canceled') }
          </p>
          <p className="my-account-details-V2__canceled-valid-through">
            { staticText.get('continueEnjoying') }
          </p>
          <span>
            <Link
              to={URL_ACCOUNT_CREATION}
              className="my-account-details-V2__item my-account-details-V2__item--link"
            >
              {staticText.get('reactivate')}
            </Link>
            <IconV2
              className="my-account-details-V2__arrow-right"
              type={ICON_TYPES.CHEVRON_RIGHT}
            />
          </span>
        </div>
      </span>
    )
  }

  return null
}

CanceledSection.propTypes = {
  variant: PropTypes.oneOf([
    CANCELED_SECTION_VARIANTS.CANCELLED_WITH_TIME_LEFT,
    CANCELED_SECTION_VARIANTS.ENTITLED_CONTACT_SUPPORT,
    CANCELED_SECTION_VARIANTS.NOT_ENTITLED_REACTIVATE,
  ]),
  staticText: ImmutablePropTypes.map,
  formattedCancelDate: PropTypes.string,
}

function PlanActionLink (props) {
  const { fullProps, subscriptionStatus, accountPause } = props

  if (subscriptionStatus === USER_ACCOUNT_PAUSED && accountPause) {
    return (
      <div className="my-account-details-V2__resume-link">
        {renderResumePlanLinkV2(fullProps)}
      </div>
    )
  }

  return (
    <div className="my-account-details-V2__change-link">
      {renderChangePlanLinkV2(fullProps)}
    </div>
  )
}

PlanActionLink.propTypes = {
  fullProps: PropTypes.object,
  subscriptionStatus: PropTypes.string,
  accountPause: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
}

function AiOnlyMessage (props) {
  const { staticText, emailCustomerServiceUrl, show } = props

  if (!show) {
    return null
  }

  return (
    <div className="my-account-details-V2__ai-only">
      <p className="my-account-details-V2__ai-only-body">
        {`${staticText.get('architectPlusBody')} `}
        <Link to={emailCustomerServiceUrl} target={TARGET_BLANK}>
          {staticText.get('architectPlusLink')}
        </Link>
        .
      </p>
    </div>
  )
}

AiOnlyMessage.propTypes = {
  staticText: ImmutablePropTypes.map,
  emailCustomerServiceUrl: PropTypes.string,
  show: PropTypes.bool,
}

/**
 * Computes all derived state for the plan details section.
 * @param {Object} props - Component props (staticText, userAccount, user, auth, planData, nextPlanData)
 * @param {*} giftPaidThroughDate - From useSelector(selectGiftPaidThroughDate)
 * @returns {Object} Derived state for rendering plan details
 */
function getPlanDetailsState (props, giftPaidThroughDate) {
  const { features } = config
  const {
    staticText,
    userAccount,
    user,
    auth,
    planData,
    nextPlanData,
    page,
    futurePlanData = List(),
  } = props
  const userLanguage = getPrimary(user.getIn(['data', 'language']))
  const currentPlanIsGift = userAccount.getIn(['details', 'data', 'gift', 'status']) === GIFT_SUBSCRIPTION_STATE.ACTIVE
  const giftSubscriptionTitle = staticText.get('giftSubscription')
  const accountPause = !!_get(features, ['userAccount', 'accountPause'])
  const currencyIso = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'currencyIso'])
  const currentPlanId = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'plan', 'productRatePlanId'])
  const endDate = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'endDate'])
  const freeTrialId = user.getIn(['data', 'freeTrialNoBillingInfo', 'ratePlanId'])
  const nextBillAmount = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'nextBillAmount'])
  const nextPlanId = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'nextPlan', 'productRatePlanId'])
  const paidThroughDate = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'paidThroughDate'])
  const subscriptionStatus = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'status'])
  const zuoraAccountId = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'billingAccountId'])
  const emailCustomerServiceUrl = getEmailCustomerServiceUrl(userLanguage)

  const currentPlanData = planData || List()
  const nextPlan = nextPlanData || List()

  // Next-plan section: resolved plans from GraphQL
  const nextPlanResolved = nextPlanData || List()
  const futurePlanResolved = futurePlanData || List()

  const currentPlanName = currentPlanData.getIn([0, 'title'])
  const remainingTime = Date.parse(endDate) - Date.now()
  const userIsEntitled = isEntitled(auth.get('subscriptions', List()))
  const nextBillPrice = formatPrice(currencyIso, nextBillAmount, false, null, userLanguage)
  const accountPausedOrCancelled = [USER_ACCOUNT_CANCELLED, USER_ACCOUNT_PAUSED].includes(subscriptionStatus)
  const cancelledWithTimeLeft = subscriptionStatus === USER_ACCOUNT_CANCELLED && remainingTime > 0
  const scheduledPause = hasScheduledPause(userAccount)
  const shouldLetReactivate = (
    ((paidThroughDate === endDate) && (subscriptionStatus === USER_ACCOUNT_CANCELLED))
    || (!currentPlanId && !nextPlanId && remainingTime <= 0)
  )
  const hasNextPlan = shouldRenderNextPlanSection(props)
  const nextPlanIsGift = planIsGift(nextPlan.get(0)) || nextPlan.getIn([0, 'subscriptionType']) === PLAN_SUBSCRIPTION_TYPE_GIFT

  const hasNextPlanNextBillDate = hasNextPlan && !nextPlanIsGift && !currentPlanIsGift
  const shouldHideNextBillDate = hideNextBillDateInCurrentPlanSection(currentPlanId, nextPlanId) || hasNextPlanNextBillDate

  const dateFormatString = ordinalDateFormatingi18n(userLanguage)
  const dateLocale = getDateLocale(userLanguage)
  const reformattedPaidThroughDate = getDateTime(paidThroughDate)
  const pauseDate = getDateTime(userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'pauseDate']))
  const resumeDate = getDateTime(userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'resumeDate']))
  const paidThrough = resumeDate || reformattedPaidThroughDate
  const nextChargeDate = currentPlanIsGift ? getDateTime(giftPaidThroughDate) : paidThrough
  const formattedNextChargeDate = formatWithLocale(
    formatDateTime(nextChargeDate),
    dateFormatString,
    { locale: dateLocale },
  )
  const nextChargeDateDisplay = subscriptionStatus === USER_ACCOUNT_PAUSED && accountPause
    ? `${nextBillPrice} ${staticText.get('on')} ${formattedNextChargeDate}`
    : formattedNextChargeDate
  const formattedCancelDate = formatWithLocale(
    formatDateTime(reformattedPaidThroughDate),
    dateFormatString,
    { locale: dateLocale },
  )
  const pauseDateFormatted = formatWithLocale(
    formatDateTime(subtractDays(pauseDate, 1)),
    dateFormatString,
    { locale: dateLocale },
  )
  const resumeDateFormatted = formatWithLocale(
    formatDateTime(subtractDays(resumeDate, 1)),
    dateFormatString,
    { locale: dateLocale },
  )

  // Next-plan section derived state
  const locale = getDateLocale(userLanguage) || (page && page.get('locale'))
  const nextPlanSku = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'nextPlan', 'planSku'])
  const futurePlanId = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'futurePlan', 'productRatePlanId'])
  const futurePlanSku = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'futurePlan', 'planSku'])
  const priceIncreasePrimarySkus = [
    PLAN_SKU_PRICE_INCREASE_2026_MONTHLY,
    PLAN_SKU_PRICE_INCREASE_2026_MONTHLY_CL,
    PLAN_SKU_PRICE_INCREASE_2026_ANNUAL,
    PLAN_SKU_PRICE_INCREASE_2026_ARCHITECT_PLUS,
  ]
  const isPriceIncreasePrimarySku = priceIncreasePrimarySkus.includes(futurePlanSku)
    && nextPlanSku !== PLAN_SKU_PRICE_INCREASE_2026_ANNUAL_SPECIAL
  const giftStartDate = userAccount.getIn(['details', 'data', 'gift', 'nextGift', 'subscriptionStartDate'])
  const giftEndDate = userAccount.getIn(['details', 'data', 'gift', 'nextGift', 'subscriptionEndDate'])
  const nextPlanStartDate = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'nextPlan', 'charges', 0, 'effectiveStartDate'])
  const nextPlanChargeDate = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'paidThroughDate'])
  const futureChargeDate = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'futurePlan', 'charges', 0, 'effectiveStartDate'])
  const nextPlanName = nextPlanId === PLAN_ID_COMPLIMENTARY ? staticText.get('comp') : nextPlanResolved.getIn([0, 'title'])
  const nextPlanShortDetails = nextPlanResolved.getIn([0, 'shortDetails'])
  const futurePlanName = futurePlanId === PLAN_ID_COMPLIMENTARY ? staticText.get('comp') : futurePlanResolved.getIn([0, 'title'])
  const futurePlanShortDetails = futurePlanResolved.getIn([0, 'shortDetails'])
  const nextPlanIsGiftResolved = planIsGift(nextPlanResolved.get(0)) || nextPlanResolved.getIn([0, 'subscriptionType']) === PLAN_SUBSCRIPTION_TYPE_GIFT
  const nextPlanIsComp = nextPlanId === PLAN_ID_COMPLIMENTARY
  const formattedNextStartDate = formatDateTime(
    getDateTime(nextPlanStartDate),
    locale,
    dateFormatString,
  )
  const formattedNextChargeDateNextSection = formatDateTime(
    getDateTime(nextPlanChargeDate),
    locale,
    dateFormatString,
  )
  const formattedFutureChargeDate = formatDateTime(
    getDateTime(futureChargeDate),
    locale,
    dateFormatString,
  )
  const formattedGiftStartDate = giftStartDate
    ? formatDateTime(getDateTime(giftStartDate), locale, ordinalDateFormatingi18n(userLanguage))
    : null
  const formattedGiftEndDate = giftEndDate
    ? formatDateTime(getDateTime(giftEndDate), locale, ordinalDateFormatingi18n(userLanguage))
    : null
  const shouldShowNextPlanSection = shouldRenderNextPlanSection(props)

  return {
    staticText,
    props,
    userAccount,
    planData: planData || List(),
    currentPlanIsGift,
    giftSubscriptionTitle,
    accountPause,
    currentPlanId,
    endDate,
    freeTrialId,
    nextBillAmount,
    nextPlanId,
    subscriptionStatus,
    zuoraAccountId,
    emailCustomerServiceUrl,
    currentPlanData,
    nextPlan,
    currentPlanName,
    remainingTime,
    userIsEntitled,
    accountPausedOrCancelled,
    cancelledWithTimeLeft,
    scheduledPause,
    shouldLetReactivate,
    hasNextPlanNextBillDate,
    shouldHideNextBillDate,
    nextChargeDateDisplay,
    formattedCancelDate,
    pauseDateFormatted,
    resumeDateFormatted,
    paidThroughDate,
    // Next-plan section
    nextPlanResolved,
    futurePlanResolved,
    locale,
    userLanguage,
    dateFormatString,
    nextPlanSku,
    futurePlanId,
    futurePlanSku,
    isPriceIncreasePrimarySku,
    giftStartDate,
    giftEndDate,
    nextPlanStartDate,
    nextPlanChargeDate,
    futureChargeDate,
    nextPlanName,
    nextPlanShortDetails,
    futurePlanName,
    futurePlanShortDetails,
    nextPlanIsGiftResolved,
    nextPlanIsComp,
    formattedNextStartDate,
    formattedNextChargeDateNextSection,
    formattedFutureChargeDate,
    formattedGiftStartDate,
    formattedGiftEndDate,
    shouldShowNextPlanSection,
  }
}

function renderUpcomingPaymentsV2 (props) {
  const giftPaidThroughDate = useSelector(selectGiftPaidThroughDate)
  const { userAccount, user, staticText } = props
  const zuoraAccountId = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'billingAccountId'])
  const nextBillAmount = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'nextBillAmount'])

  if (!zuoraAccountId || !nextBillAmount) {
    return null
  }

  const userLanguage = getPrimary(user.getIn(['data', 'language']))
  const currencyIso = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'currencyIso'])
  const paidThroughDate = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'paidThroughDate'])
  const resumeDate = getDateTime(userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'resumeDate']))
  const currentPlanIsGift = userAccount.getIn(['details', 'data', 'gift', 'status']) === GIFT_SUBSCRIPTION_STATE.ACTIVE
  const reformattedPaidThroughDate = paidThroughDate
    ? (formatDateWithTimezonOffset(new Date(getDateTime(paidThroughDate))) || getDateTime(paidThroughDate))
    : null
  const paidThrough = resumeDate || reformattedPaidThroughDate

  if (currentPlanIsGift && !giftPaidThroughDate) {
    return null
  }

  if (!currentPlanIsGift && !paidThrough) {
    return null
  }

  const nextChargeDate = currentPlanIsGift
    ? (formatDateWithTimezonOffset(new Date(getDateTime(giftPaidThroughDate))) || getDateTime(giftPaidThroughDate))
    : paidThrough
  const dateFormatString = ordinalDateFormatingi18n(userLanguage)
  const dateLocale = getDateLocale(userLanguage)
  const formattedNextChargeDate = formatWithLocale(
    formatDateTime(nextChargeDate),
    dateFormatString,
    { locale: dateLocale },
  )
  const price = formatPrice(currencyIso, nextBillAmount, false, null, userLanguage)
  const plusTaxSuffix = isTaxable(props) ? ` (${staticText.get('preTax')})` : ''

  return (
    <div className="my-account-details-V2__plan-section my-account-details-V2__upcoming-payments-section">
      <div className="my-account-details-V2__plan-details">
        <H5 className="my-account-details-V2__item my-account-details-V2__item--plan-current">
          {`${staticText.get('upcomingPayments')}:`}
        </H5>
        <p className="my-account-details-V2__item my-account-details-V2__item--short-details">
          {price}{plusTaxSuffix} {staticText.get('dueOn')} {formattedNextChargeDate}
        </p>
      </div>
    </div>
  )
}

function renderPlanDetailsV2 (props, shouldReactivate, isAIOnly) {
  const giftPaidThroughDate = useSelector(selectGiftPaidThroughDate)
  const state = getPlanDetailsState(props, giftPaidThroughDate)
  const {
    staticText,
    zuoraAccountId,
    freeTrialId,
    currentPlanName,
    subscriptionStatus,
    currentPlanIsGift,
    giftSubscriptionTitle,
    accountPause,
    resumeDateFormatted,
    accountPausedOrCancelled,
    currentPlanData,
    planData,
    scheduledPause,
    pauseDateFormatted,
    cancelledWithTimeLeft,
    formattedCancelDate,
    shouldLetReactivate,
    userIsEntitled,
    emailCustomerServiceUrl,
  } = state

  if (!zuoraAccountId && freeTrialId) {
    return (
      renderFreeTrialDetails(props)
    )
  }

  if (shouldReactivate) {
    return (
      <ReactivationDetails {...props} />
    )
  }

  const planHeader = (
    <PlanDetailsHeader
      currentPlanName={currentPlanName}
      subscriptionStatus={subscriptionStatus}
      currentPlanIsGift={currentPlanIsGift}
      staticText={staticText}
    />
  )

  const planDetails = (
    <PlanDetailsBody
      fullProps={props}
      subscriptionStatus={subscriptionStatus}
      accountPause={accountPause}
      resumeDateFormatted={resumeDateFormatted}
      accountPausedOrCancelled={accountPausedOrCancelled}
      currentPlanData={currentPlanData}
      currentPlanIsGift={currentPlanIsGift}
      planData={planData}
      giftSubscriptionTitle={giftSubscriptionTitle}
      scheduledPause={scheduledPause}
      staticText={staticText}
      pauseDateFormatted={pauseDateFormatted}
    />
  )

  let canceledSection = null
  if (cancelledWithTimeLeft) {
    canceledSection = (
      <CanceledSection
        variant={CANCELED_SECTION_VARIANTS.CANCELLED_WITH_TIME_LEFT}
        staticText={staticText}
        formattedCancelDate={formattedCancelDate}
      />
    )
  } else if (shouldLetReactivate && userIsEntitled) {
    canceledSection = (
      <CanceledSection
        variant={CANCELED_SECTION_VARIANTS.ENTITLED_CONTACT_SUPPORT}
        staticText={staticText}
        formattedCancelDate={formattedCancelDate}
      />
    )
  } else if (shouldLetReactivate && !userIsEntitled) {
    canceledSection = (
      <CanceledSection
        variant={CANCELED_SECTION_VARIANTS.NOT_ENTITLED_REACTIVATE}
        staticText={staticText}
        formattedCancelDate={formattedCancelDate}
      />
    )
  }

  const actionLink = (
    <PlanActionLink
      fullProps={props}
      subscriptionStatus={subscriptionStatus}
      accountPause={accountPause}
    />
  )

  const aiOnlyMessage = (
    <AiOnlyMessage
      staticText={staticText}
      emailCustomerServiceUrl={emailCustomerServiceUrl}
      show={!aiFullAccessActive && isAIOnly}
    />
  )

  const sectionClassName = !aiFullAccessActive && isAIOnly ? ' my-account-details-V2__plan-section--ai-only' : ''

  return (
    <PlanDetailsSectionTemplate
      planHeader={planHeader}
      planDetails={planDetails}
      canceledSection={canceledSection}
      actionLink={actionLink}
      aiOnlyMessage={aiOnlyMessage}
      className={sectionClassName}
    />
  )
}
/* eslint-enable max-len */

function NextPlanPlaceholder () {
  return (
    <div className="my-account-details-V2__next-plan-section">
      <div className="my-account-details-V2__plan-placeholder">
        <div className="my-account-details-V2__plan-placeholder-name" />
        <div className="my-account-details-V2__plan-placeholder-name" />
        <div className="my-account-details-V2__plan-placeholder-details" />
      </div>
    </div>
  )
}

function NextPlanShortDetails (props) {
  const {
    nextPlanIsComp,
    isPriceIncreasePrimarySku,
    staticText,
    formattedNextStartDate,
    formattedNextChargeDate,
    futurePlanShortDetails,
    nextPlanShortDetails,
  } = props

  if (nextPlanIsComp && !isPriceIncreasePrimarySku) {
    return (
      <p className="my-account-details-V2__next-plan-short-details">
        { staticText.get('effective') }  { formattedNextStartDate } - { formattedNextChargeDate }
      </p>
    )
  }

  return (
    <p className="my-account-details-V2__next-plan-short-details">
      { isPriceIncreasePrimarySku && futurePlanShortDetails ? futurePlanShortDetails : nextPlanShortDetails || '' }
    </p>
  )
}

NextPlanShortDetails.propTypes = {
  nextPlanIsComp: PropTypes.bool,
  isPriceIncreasePrimarySku: PropTypes.bool,
  staticText: ImmutablePropTypes.map,
  formattedNextStartDate: PropTypes.string,
  formattedNextChargeDate: PropTypes.string,
  futurePlanShortDetails: PropTypes.string,
  nextPlanShortDetails: PropTypes.string,
}

function NextPlanGiftDates (props) {
  const {
    show,
    staticText,
    formattedGiftStartDate,
    formattedGiftEndDate,
  } = props

  if (!show || !formattedGiftStartDate || !formattedGiftEndDate) {
    return null
  }

  return (
    <>
      <p className="my-account-details-V2__next-plan-short-details">
        {staticText.get('giftStarts')}
        { formattedGiftStartDate }
      </p>
      <p className="my-account-details-V2__next-plan-short-details">
        {staticText.get('giftEnds')}
        { formattedGiftEndDate }
      </p>
    </>
  )
}

NextPlanGiftDates.propTypes = {
  show: PropTypes.bool,
  staticText: ImmutablePropTypes.map,
  formattedGiftStartDate: PropTypes.string,
  formattedGiftEndDate: PropTypes.string,
}

/**
 * Presentational layout for the next plan section. Renders slots in BEM structure.
 */
function NextPlanSectionTemplate (props) {
  const {
    title,
    planName,
    shortDetails,
    giftDates,
  } = props

  return (
    <div className="my-account-details-V2__next-plan-section">
      {title}
      {planName}
      {shortDetails}
      {giftDates}
    </div>
  )
}

NextPlanSectionTemplate.propTypes = {
  title: PropTypes.node,
  planName: PropTypes.node,
  shortDetails: PropTypes.node,
  giftDates: PropTypes.node,
}

function renderNextPlanV2 (props) {
  const giftPaidThroughDate = useSelector(selectGiftPaidThroughDate)
  const state = getPlanDetailsState(props, giftPaidThroughDate)
  const {
    staticText,
    shouldShowNextPlanSection,
    nextPlanResolved,
    nextPlanName,
    futurePlanName,
    isPriceIncreasePrimarySku,
    nextPlanIsComp,
    formattedNextStartDate,
    formattedNextChargeDateNextSection,
    nextPlanShortDetails,
    futurePlanShortDetails,
    nextPlanIsGiftResolved,
    giftStartDate,
    giftEndDate,
    formattedGiftStartDate,
    formattedGiftEndDate,
  } = state

  if (!shouldShowNextPlanSection) {
    return null
  }

  if (!List.isList(nextPlanResolved) || !nextPlanResolved.size) {
    return <NextPlanPlaceholder />
  }

  const title = (
    <div className="my-account-details-V2__next-plan-title">
      {staticText.get('nextPlan')}
    </div>
  )

  const planName = (
    <div>
      <p className="my-account-details-V2__next-plan-name">
        {isPriceIncreasePrimarySku && futurePlanName ? futurePlanName : nextPlanName || ''}
      </p>
    </div>
  )

  const shortDetails = (
    <NextPlanShortDetails
      nextPlanIsComp={nextPlanIsComp}
      isPriceIncreasePrimarySku={isPriceIncreasePrimarySku}
      staticText={staticText}
      formattedNextStartDate={formattedNextStartDate}
      formattedNextChargeDate={formattedNextChargeDateNextSection}
      futurePlanShortDetails={futurePlanShortDetails}
      nextPlanShortDetails={nextPlanShortDetails}
    />
  )

  const giftDates = (
    <NextPlanGiftDates
      show={!!(nextPlanIsGiftResolved && giftStartDate && giftEndDate)}
      staticText={staticText}
      formattedGiftStartDate={formattedGiftStartDate}
      formattedGiftEndDate={formattedGiftEndDate}
    />
  )

  return (
    <NextPlanSectionTemplate
      title={title}
      planName={planName}
      shortDetails={shortDetails}
      giftDates={giftDates}
    />
  )
}

function renderNonErrorBannerMessages (props) {
  const { userAccount } = props
  const scheduledOrActivePause = hasScheduledOrActivePause(userAccount)

  return (
    <div className="my-account-details-V2__messages-section">
      <MyAccountMessages
        userAccount={userAccount}
        region={bottom}
        scheduledOrActivePause={scheduledOrActivePause}
      />
    </div>
  )
}

function renderCancelOptionV2 (props) {
  const { staticText, userAccount, user } = props
  const subscriptionStatus = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'status'])
  const zuoraAccountId = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'billingAccountId'])
  const freeTrialId = user.getIn(['data', 'freeTrialNoBillingInfo', 'ratePlanId'])

  if (!zuoraAccountId && freeTrialId) {
    return null
  } if (subscriptionStatus !== USER_ACCOUNT_CANCELLED) {
    return (
      <div className="my-account-details-V2__cancel-section">
        <div className="my-account-details-V2__cancel-text">
          <H5 className="my-account-details-V2__cancel-title">
            { staticText.get('cancelMembership') }
          </H5>
        </div>
        <div className="my-account-details-V2__cancel-link">
          { renderCancelLinkV2(props) }
        </div>
      </div>
    )
  }
  return null
}

function renderZipUpdateModal ({
  resetBillingAddressZuoraPaypalState,
  updateBillingAddressZuoraPaypal,
  requiresUpdate,
  userAccount,
  user,
  staticText,
  zipCode,
  state,
}) {
  const { validZip, setValidZip, openZipcodeModal } = state
  const processing = userAccount.getIn(['billingZipcodeUpdates', 'processing'])
  const success = userAccount.getIn(['billingZipcodeUpdates', 'success'])
  const errorCode = userAccount.getIn(['billingZipcodeUpdates', 'errorCode'], '')
  const error = userAccount.getIn(['billingZipcodeUpdates', 'error'], false)
  const userLanguage = getPrimary(user.getIn(['data', 'language']))
  let errorText = ''

  if (errorCode === 'BILL_TO_UPDATE' || errorCode === 'SOLD_TO_CONTACT') {
    errorText = (
      <React.Fragment>
        {`${staticText.get('zipBackendError')} `}
        <Link
          to={getEmailCustomerServiceUrl(userLanguage)}
          className="my-account-details-V2__zip-error-link"
        >
          {staticText.get('zipBackendErrorLink')}
        </Link>
        {` ${staticText.get('zipBackendError2')}`}
      </React.Fragment>
    )
  } else if (errorCode === 'POSTAL_CODE_ERROR') {
    errorText = staticText.get('zipInvalidError')
  }

  return (
    <div className="my-account-details-V2__zip-modal">
      <div className="my-account-details-V2__zip-modal-wrapper">
        <H2 as={HEADING_TYPES.H4}>
          {requiresUpdate ? (
            staticText.get('zipModalTitleRequired', '')
          ) : (
            staticText.get('zipModalTitle', '')
          )}
        </H2>
        {requiresUpdate ? (
          <p className="my-account-details-V2__zipcode-message">{staticText.get('zipDesc', '')}</p>
        ) : null}
        {error ? (
          <p className="my-account-details-V2__zipcode-error">
            {errorText}
          </p>
        ) : null}
        {success ? (
          <p className="my-account-details-V2__zipcode-success">
            {staticText.get('zipcodeUpdateSuccess')}
          </p>
        ) : null}
        <FormsyForm
          onValid={() => setValidZip(true)}
          onInvalid={() => setValidZip(false)}
          onValidSubmit={(data = {}) => {
            updateBillingAddressZuoraPaypal({
              requireZipcodeUpdate2021: requiresUpdate,
              postalCode: data.zip,
            })
          }}
        >
          <TextInput
            label={staticText.get('zipcode', '')}
            validations={{
              matchRegexp: /^\d+/,
            }}
            validationErrors={{
              matchRegexp: staticText.get('numOnly'),
            }}
            value={zipCode}
            maxLength={5}
            name="zip"
            required
            disabled={success}
          />
          <div className="my-account-details-V2__buttons">
            {success ? (
              <Button
                className="my-account-details-V2__continue button--stacked"
                onClick={() => {
                  openZipcodeModal(false)
                  resetBillingAddressZuoraPaypalState()
                }}
                type={TYPES.PRIMARY}
              >{staticText.get('zipModalClose')}</Button>
            ) : (
              <Button
                className={`my-account-details-V2__zip-confirm button--stacked my-account-details-V2__zip-confirm--${userLanguage}`}
                disabled={!validZip || processing}
                type={TYPES.PRIMARY}
                submit
              >{staticText.get('zipConfirm', '')}
              </Button>
            )}
          </div>
        </FormsyForm>
        {processing ? (
          <div className="my-account-details-V2__sherpa">
            <Sherpa type={TYPE_LARGE} />
          </div>
        ) : null}
        <Button
          onClick={() => {
            openZipcodeModal(false)
            resetBillingAddressZuoraPaypalState()
          }}
          className="my-account-details-V2__modal-close"
          type={TYPES.ICON}
          icon={ICON_TYPES.CLOSE}
          size={SIZES.XSMALL}
        />
      </div>
    </div>
  )
}

function renderZipSection (props, state) {
  const {
    zipcodeModelOpen,
    openZipcodeModal,
  } = state
  const {
    staticText,
    userAccount,
    user,
    featureTracking,
    updateBillingAddressZuoraPaypal,
    resetBillingAddressZuoraPaypalState,
  } = props
  const zipCode = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'billingAddress', 'postalCode'])
  const requiresUpdate = featureTracking.getIn(['data', 'zipcodeUpdate2021'], false) !== true
  const userLanguage = getPrimary(user.getIn(['data', 'language']))

  return (
    <div className="my-account-details-V2__zip-section">
      <div className="my-account-details-V2__zip-text">
        <H5 className="my-account-details-V2__zip-title">
          { staticText.get('zipcode') }
        </H5>
        <p>
          {zipCode}
        </p>
        <p className="my-account-details-V2__zip-description">
          <span className="my-account-details-V2__zip-disclaimer-title">
            { staticText.get('zipDisclaimerTitle') }
          </span>
          { staticText.get('zipDisclaimer') }
        </p>
      </div>
      <div className="my-account-details-V2__zip-link">
        <div className="my-account-details-V2__zip-update-link">
          <Button
            className={`my-account-details-V2__item my-account-details-V2__item--link my-account-details-V2__update-zip my-account-details-V2__update-zip--${userLanguage}`}
            onClick={() => openZipcodeModal(true)}
            type={TYPES.LINK}
            submit
          >
            { staticText.get('updateZipCode') }
          </Button>
          <IconV2
            className="my-account-details-V2__arrow-right"
            type={ICON_TYPES.CHEVRON_RIGHT}
          />
        </div>
      </div>
      {zipcodeModelOpen ? renderZipUpdateModal({
        resetBillingAddressZuoraPaypalState,
        updateBillingAddressZuoraPaypal,
        requiresUpdate,
        userAccount,
        user,
        staticText,
        zipCode,
        state,
      }) : null}
    </div>
  )
}

function renderPauseOptionV2 (props) {
  const { staticText, userAccount, user } = props
  const userLanguage = getPrimary(user.getIn(['data', 'language']))
  const scheduledPause = hasScheduledPause(userAccount)
  const pauseMonths = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'pauseMonths'])

  // Dates
  const dateFormatString = ordinalDateFormatingi18n(userLanguage)
  const dateLocale = getDateLocale(userLanguage)
  const pauseDate = getDateTime(userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'pauseDate']))
  const resumeDate = getDateTime(userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'resumeDate']))
  const pauseEnd = getDateTime(subtractDays(resumeDate, 1))
  const pauseDateFormatted = formatWithLocale(
    formatDateTime(pauseDate),
    dateFormatString,
    { locale: dateLocale },
  )
  const pauseEndFormatted = formatWithLocale(
    formatDateTime(pauseEnd),
    dateFormatString,
    { locale: dateLocale },
  )
  const pauseStart = pauseDateFormatted.split(',')[0]
  if (userPauseAllowed(props)) {
    return (
      <div className="my-account-details-V2__pause-section">
        <div className="my-account-details-V2__pause-text">
          <H5 className="my-account-details-V2__pause-title">
            { scheduledPause ? staticText.get('pauseScheduled') : staticText.get('pauseMembership') }
          </H5>
          {
            scheduledPause ? (
              <div className="my-account-details-V2__pause-scheduled-info">
                <p className="my-account-details-V2__item my-account-details-V2__item--short-details">
                  <span className=" my-account-details-V2__item--paused">
                    {`${pauseMonths} ${staticText.get('month')} ${staticText.get('pause')}: `}
                  </span>
                  {pauseStart} - {pauseEndFormatted}
                </p>
              </div>
            ) : null
          }
        </div>
        <div className="my-account-details-V2__pause-link">
          { scheduledPause ? renderRemovePauseLink(props) : renderPauseLinkV2(props) }
        </div>
      </div>
    )
  }
  return null
}

function renderResumeModal (props) {
  const {
    updateUserAccountResume,
    isProcessingAccountResume,
    renderModal,
    userAccount,
    user,
    page,
  } = props
  const locale = page.get('locale')
  const userLanguage = getPrimary(user.getIn(['data', 'language']))
  const status = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'status'])
  const nextBillAmount = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'nextBillAmount'])
  const paidThrough = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'paidThroughDate'])
  const resumeDate = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'resumeDate'])
  const currencyIso = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'currencyIso'])
  const price = formatPrice(currencyIso, nextBillAmount, false, null, userLanguage)
  const dateFormatString = ordinalDateFormatingi18n(userLanguage)
  const dateLocale = getDateLocale(userLanguage)
  const dateFormat = 'YYYY-MM-DD'
  const today = formatDateTime(getCurrentTime(), locale, dateFormat)
  const formattedResumeDate = formatDateTime(getDateTime(resumeDate), locale, dateFormat)
  // set the default nextBillingDate as the paidThroughDate
  // this will cover the case of the user still being active before their pause takes effect
  let nextBillingDate = formatDateTime(getDateTime(paidThrough), locale, dateFormat)

  // add a month to nextBillingDate until we hit the proper next bill date
  while (nextBillingDate && nextBillingDate < today && nextBillingDate < formattedResumeDate) {
    nextBillingDate = formatDateTime(addMonths(nextBillingDate, 1), locale, dateFormat)
  }

  const nextStandardBillingDate = formatWithLocale(
    nextBillingDate,
    dateFormatString,
    { locale: dateLocale },
  )

  renderModal(TYPE_PAUSE_RESUME, {
    price,
    status,
    userAccount,
    userLanguage,
    onReturnFocus: () => null,
    resumeAccount: updateUserAccountResume,
    hideDismiss: isProcessingAccountResume,
    resumeDate: nextStandardBillingDate,
  })
}

function renderResumePlanLinkV2 (props) {
  const { staticText } = props
  return (
    <div className="my-account-details-V2__resume-plan-link">
      <span>
        <Button
          type={TYPES.GHOST}
          onClick={() => renderResumeModal(props)}
          className="my-account-details-V2__item my-account-details-V2__item--link my-account-details-V2__item--resume-link"
        >
          {staticText.get('resumeButton')}
        </Button>
        <IconV2
          className="my-account-details-V2__arrow-right"
          type={ICON_TYPES.CHEVRON_RIGHT}
        />
      </span>

    </div>
  )
}

function renderChangePlanLinkV2 (props) {
  const { staticText, userAccount, isAIOnly } = props
  const scheduledOrActivePause = hasScheduledOrActivePause(userAccount)
  const subscriptionStatus = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'status'])
  const endDate = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'endDate'])
  const paymentSourceType = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'paymentSource', 'type'])
  const remainingTime = Date.parse(endDate) - Date.now()
  const errorCode = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'errors', 0, 'status'])
  const lastTransactionStatus = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'paymentSource', 'lastTransactionStatus'])
  const lastTransactionDeclined = lastTransactionStatus === USER_ACCOUNT_TRANSACTION_STATUS_DECLINED
  const hasGiftSubscription = !!userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'giftStartDate'])

  if (errorCode > 299) {
    return (
      null
    )
  }

  if (!aiFullAccessActive && isAIOnly) {
    return null
  }

  if (
    !paymentSourceType
    && subscriptionStatus === USER_ACCOUNT_CANCELLED
    && endDate
    && remainingTime > 0
  ) {
    return (
      <div className="my-account-details-V2__reactivate-contact">
        { staticText.get('reactivateContact')}
      </div>
    )
  }

  if (subscriptionStatus !== USER_ACCOUNT_CANCELLED
    && !scheduledOrActivePause
    && !hasGiftSubscription) {
    return (
      <div className="my-account-details-V2__change-plan-link">
        {
          showChangePlanLink(props)
            ? <span>
              <Link
                to={URL_ACCOUNT_CHANGE_PLAN}
                className="my-account-details-V2__item my-account-details-V2__item--link"
              >
                {staticText.get('change')}
              </Link>
              <IconV2
                className="my-account-details-V2__arrow-right"
                type={ICON_TYPES.CHEVRON_RIGHT}
              />
            </span>
            : null
        }
        {
          lastTransactionDeclined
            ? <span>
              <Link
                to={URL_ACCOUNT_UPDATE_PAYMENT}
                className="my-account-details-V2__item my-account-details-V2__item--link"
              >
                { staticText.get('update') }
              </Link>
              <IconV2
                className="my-account-details-V2__arrow-right"
                type={ICON_TYPES.CHEVRON_RIGHT}
              />
            </span>
            : null
        }
      </div>
    )
  }

  return null
}

function renderCancelLinkV2 (props) {
  const {
    staticText,
    userAccount,
    renderModal,
    resetUserAccountManageSubscriptionData,
    resetUserComp,
    history,
    auth,
    userLanguage,
    setEventDefault,
    sendOptimizelyFeatureEvent,
  } = props
  const subscriptionStatus = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'status'])
  const endDate = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'endDate'])
  const paymentSourceType = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'paymentSource', 'type'])
  const remainingTime = Date.parse(endDate) - Date.now()
  const errorCode = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'errors', 0, 'status'])

  const showCancelWarningModal = shouldRenderCancelWarningModal(props)
  const goToCancelPage = (url = '') => {
    historyRedirect({
      history,
      url: url || URL_ACCOUNT_CANCEL,
      auth,
      language: userLanguage,
    })
  }

  const openModal = (modalType, onContinue) => {
    resetUserAccountManageSubscriptionData()
    resetUserComp()
    renderModal(modalType, {
      hideOverflow: true,
      hideDismiss: false,
      url: URL_ACCOUNT_CANCEL,
      onCancel: onContinue,
      type: MODAL_TYPES.MOBILE_BOTTOM_ALIGNED,
    })
  }

  const handleCancelClick = () => {
    setEventDefault(CANCEL_FLOW_CANCEL_CLICKED_GA4_EVENT)
    sendOptimizelyFeatureEvent({ eventName: 'cancel_flow_cancel_clicked' })

    if (showCancelWarningModal) {
      openModal(TYPE_MY_ACCOUNT_CANCEL_WARNING, goToCancelPage)
    } else {
      goToCancelPage()
    }
  }

  const cancelLinkButton = (
    <Button
      type={TYPES.LINK}
      className="my-account-details-V2__item my-account-details-V2__item--link"
      onClick={handleCancelClick}
    >
      {staticText.get('cancelMembership')}
    </Button>
  )

  const renderCancelLink = () => cancelLinkButton

  if (errorCode > 299) {
    return (
      null
    )
  } if (
    !paymentSourceType
    && subscriptionStatus === USER_ACCOUNT_CANCELLED
    && endDate
    && remainingTime > 0
  ) {
    return (
      <div className="my-account-details-V2__reactivate-contact">
        { staticText.get('reactivateContact')}
      </div>
    )
  } if (subscriptionStatus !== USER_ACCOUNT_CANCELLED) {
    return (
      <div className="my-account-details-V2__cancel-subscription-link">
        {renderCancelLink()}
          <IconV2
            className="my-account-details-V2__arrow-right"
            type={ICON_TYPES.CHEVRON_RIGHT}
          />
      </div>
    )
  }

  return (
    <div className="my-account-details-V2__plan-links">
      <ButtonSignUp
        type={BUTTON_SIGN_UP_TYPE_LINK}
        className="my-account-details-V2__item my-account-details-V2__item--link"
        text={staticText.get('reactivate')}
        scrollToTop
      />
    </div>
  )
}

function renderRemovePauseLink (props) {
  const { staticText } = props
  return (
    <div className="my-account-details-V2__remove-pause-link">
      <span>
        <Button
          type={TYPES.GHOST}
          onClick={() => renderResumeModal(props)}
          className="my-account-details-V2__item my-account-details-V2__item--link"
        >
          {staticText.get('removePause')}
        </Button>

        <IconV2
          className="my-account-details-V2__arrow-right"
          type={ICON_TYPES.CHEVRON_RIGHT}
        />
      </span>
    </div>
  )
}

function renderPauseLinkV2 (props) {
  const {
    staticText,
    userAccount,
  } = props
  const errorCode = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'errors', 0, 'status'])

  const handlePauseAccountClick = () => {}

  if (errorCode > 299) {
    return (
      null
    )
  }

  return (
    <div className="my-account-details-V2__pause-subscription-link">
      <Link
        to={URL_ACCOUNT_PAUSE}
        className="my-account-details-V2__item my-account-details-V2__item--link"
        onClick={handlePauseAccountClick}
      >
        { staticText.get('pauseMembership') }
      </Link>
      <IconV2
        className="my-account-details-V2__arrow-right"
        type={ICON_TYPES.CHEVRON_RIGHT}
      />
    </div>
  )
}

function renderPaymentInfoDisplay (props) {
  const { staticText, userAccount } = props
  const lastFour = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'paymentSource', 'maskedCardNumber'])
  const paymentSourceType = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'paymentSource', 'type'])
  const expMonth = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'paymentSource', 'expMonth'])
  const expYear = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'paymentSource', 'expYear'])
  const paypalRegex = /paypal/ig
  let cardType = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'paymentSource', 'cardType'])
  // If the paymentSourceType is of paypal origin
  if (paypalRegex.test(paymentSourceType)) {
    cardType = 'Paypal'
  }

  return (
    <div className="my-account-details-V2__payment-section" id="payment-info">
      <div className="my-account-details-V2__payment-text">
        <H5 className="my-account-details-V2__payment-info--title">
          { staticText.get('paymentMethod') }
        </H5>
        { lastFour
          ? <p className="my-account-details-V2__item">
            { cardType } { lastFour }
          </p>
          : <p className="my-account-details-V2__item">
            { cardType }
          </p>
        }
        { expMonth && expYear
          ? <div>
            <p className="my-account-details-V2__item">
              { staticText.get('expirationDate') }: { expMonth } / { expYear }
            </p>
          </div> : null
        }
      </div>
      <div className="my-account-details-V2__payment-link">
        <div className="my-account-details-V2__update-payment-link">
          <Link
            to={URL_ACCOUNT_UPDATE_PAYMENT}
            className="my-account-details-V2__item my-account-details-V2__item--link"
          >
            { staticText.get('update') }
            <IconV2
              className="my-account-details-V2__arrow-right"
              type={ICON_TYPES.CHEVRON_RIGHT}
            />
          </Link>
        </div>
      </div>
    </div>
  )
}

function renderMyAccountDetailsPageV2 (props, state) {
  const {
    userAccount,
    isAIOnly,
  } = props
  const zuoraBillingAccountId = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'billingAccountId'])
  const reactivationRequired = userShouldReactivate(props)
  const scheduledPause = hasScheduledPause(userAccount)

  return (
    <div className="my-account-details-V2">
      <div className="my-account-details-V2__plan">
        {renderUpcomingPaymentsV2(props)}
        {renderPlanDetailsV2(props, reactivationRequired, isAIOnly)}
        {renderNextPlanV2(props)}
        {scheduledPause && !isAIOnly && renderPauseOptionV2(props)}
        {!isAIOnly && renderNonErrorBannerMessages(props)}
      </div>
      {
        zuoraBillingAccountId && !reactivationRequired
          ? renderPaymentInfoDisplay(props)
          : null
      }
      {isTaxable(props) && isPrimaryAccountProfile(props) ? (
        <div className="my-account-details-V2__plan">
          {renderZipSection(props, state)}
        </div>
      ) : null}
      {
        isPrimaryAccountProfile(props) && !_get(config, ['features', 'zuoraOutage'])
          ? <div className="my-account-V2__content my-account-V2__content--invoices">
            <MyAccountInvoices />
          </div>
          : null
      }
      <div className="my-account-details-V2__plan">
        {!scheduledPause && !isAIOnly && renderPauseOptionV2(props)}
        {renderCancelOptionV2(props, reactivationRequired)}
      </div>
    </div>
  )
}

const MyAccountDetailsPage = (props) => {
  const [validZip, setValidZip] = useState(true)
  const [zipcodeModelOpen, openZipcodeModal] = useState(false)

  useEffect(() => {
    const {
      userAccount,
      isProcessingAccountResume,
    } = props

    const hasError = !userAccount.getIn(['manageSubscription', 'data', 'errors'], List()).isEmpty()
    // call render modal again so that hideDismiss gets updated and errors render
    if (isProcessingAccountResume || hasError) {
      renderResumeModal(props)
    }
  }, [props.isProcessingAccountResume, props.userAccount])

  return (renderMyAccountDetailsPageV2(props, {
    validZip, zipcodeModelOpen, setValidZip, openZipcodeModal,
  }))
}

MyAccountDetailsPage.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  userAccount: ImmutablePropTypes.map.isRequired,
  featureTracking: ImmutablePropTypes.map.isRequired,
  page: ImmutablePropTypes.map.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  plans: ImmutablePropTypes.map.isRequired,
  userProfiles: ImmutablePropTypes.map,
  resetUserComp: PropTypes.func.isRequired,
  resetUserAccountManageSubscriptionData: PropTypes.func.isRequired,
  updateBillingAddressZuoraPaypal: PropTypes.func.isRequired,
  resetBillingAddressZuoraPaypalState: PropTypes.func.isRequired,
  planData: ImmutablePropTypes.list.isRequired,
  nextPlanData: ImmutablePropTypes.list.isRequired,
  isAIOnly: PropTypes.bool,
}

export default compose(
  connectRedux(
    (state) => ({
      page: state.page,
      auth: state.auth,
      user: state.user,
      plans: state.plans,
      userAccount: state.userAccount,
      userProfiles: state.userProfiles,
      featureTracking: state.featureTracking,
      staticText: state.staticText.getIn(['data', 'myAccountDetails', 'data']),
      isProcessingAccountResume:
        state.userAccount.getIn(['manageSubscription', 'data', 'accountResumeProcessing'], false)
        || state.userAccount.getIn(['manageSubscription', 'data', 'success'], false),
      isAIOnly: state.userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'plan', 'planCategory']) === PLAN_CATEGORY_AI_ONLY,
      userLanguage: state.user.getIn(['data', 'language', 0], EN),
      optimizelyFeature: state.optimizelyFeature,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        renderModal: actions.dialog.renderModal,
        setOverlayDialogVisible: actions.dialog.setOverlayDialogVisible,
        resetUserComp: actions.subscription.resetUserComp,
        resetUserAccountManageSubscriptionData:
          actions.userAccount.resetUserAccountManageSubscriptionData,
        updateUserAccountResume: actions.userAccount.updateUserAccountResume,
        updateBillingAddressZuoraPaypal: actions.userAccount.updateBillingAddressZuoraPaypal,
        resetBillingAddressZuoraPaypalState:
          actions.userAccount.resetBillingAddressZuoraPaypalState,
        setEventDefault: actions.eventTracking.setEventDefault,
        sendOptimizelyFeatureEvent: actions.optimizelyFeature.sendOptimizelyFeatureEvent,
      }
    },
  ),
)(MyAccountDetailsPage)
